export function Card({ className = '', children }) {
  return (
    <div className={`bg-paper-raised border border-line rounded-m ${className}`}>
      {children}
    </div>
  );
}

export function CardHeader({ title, action }) {
  return (
    <div className="flex items-center justify-between px-5 py-3.5 border-b border-line-soft">
      <h4 className="font-display font-bold text-[15px] text-ink">{title}</h4>
      {action}
    </div>
  );
}

export function KpiTile({ label, value, delta, deltaTone = 'success' }) {
  const deltaColor = deltaTone === 'success' ? 'text-success' : deltaTone === 'critical' ? 'text-critical' : 'text-ink-soft';
  return (
    <div className="bg-paper-raised border border-line rounded-m p-4">
      <span className="block text-[11px] font-bold uppercase tracking-wider text-transit-deep mb-2 font-body">{label}</span>
      <div className="flex items-end justify-between gap-2">
        <span className="font-display font-extrabold text-[22px] text-ink tabular-nums">{value}</span>
        {delta && <span className={`text-xs font-bold tabular-nums ${deltaColor}`}>{delta}</span>}
      </div>
    </div>
  );
}

// Colour-coded home-dashboard tile: tinted card, solid icon chip, big number,
// optional caption underneath. Clickable when `onClick` is given.
const STAT_TONES = {
  transit:   { card: 'bg-transit-tint border-line',     chip: 'bg-transit',   text: 'text-transit-deep' },
  clearance: { card: 'bg-clearance-tint border-line', chip: 'bg-clearance', text: 'text-clearance-deep' },
  success:   { card: 'bg-success-tint border-line',     chip: 'bg-success',   text: 'text-success' },
  caution:   { card: 'bg-caution-tint border-line',     chip: 'bg-caution',   text: 'text-caution' },
  critical:  { card: 'bg-critical-tint border-line',   chip: 'bg-critical',  text: 'text-critical' },
  slate:     { card: 'bg-line-soft border-line',              chip: 'bg-slate2',    text: 'text-ink-soft' },
};

export function StatTile({ label, value, caption, icon: Icon, tone = 'transit', onClick }) {
  const t = STAT_TONES[tone] || STAT_TONES.transit;
  const Tag = onClick ? 'button' : 'div';
  return (
    <Tag onClick={onClick}
      className={`text-left border rounded-m p-4 flex flex-col gap-3 ${t.card}
        ${onClick ? 'cursor-pointer transition-shadow hover:shadow-2 focus:outline-none focus:ring-2 focus:ring-transit' : ''}`}>
      <div className="flex items-center justify-between gap-2">
        <span className={`text-[11.5px] font-bold uppercase tracking-wider font-body ${t.text}`}>{label}</span>
        {Icon && <span className={`w-8 h-8 rounded-s grid place-items-center text-white shrink-0 ${t.chip}`}><Icon size={17} /></span>}
      </div>
      <span className="font-display font-extrabold text-[28px] leading-none text-ink tabular-nums">{value}</span>
      {caption && <span className="text-xs text-ink-soft font-semibold -mt-1">{caption}</span>}
    </Tag>
  );
}
